/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {Array<number>}
     * @memberof Position
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Position
     */
    extensions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    type?: string;
}

/**
 * Check if a given object implements the Position interface.
 */
export function instanceOfPosition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PositionFromJSON(json: any): Position {
    return PositionFromJSONTyped(json, false);
}

export function PositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Position {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'extensions': !exists(json, 'extensions') ? undefined : json['extensions'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function PositionToJSON(value?: Position | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coordinates': value.coordinates,
        'extensions': value.extensions,
        'type': value.type,
    };
}

